import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { SocketContext } from "../../context/socket";
import { useDispatch } from "react-redux";
import { setLastAnswer } from "../../store/slices/PlayerSlice";

export function Lie() {
  const { t } = useTranslation();
  const question = useSelector((state: RootState) => state.player.question);
  const room = useSelector((state: RootState) => state.player.code);
  const name = useSelector((state: RootState) => state.player.playerName);
  const [show, setShow] = useState(1);
  const [showError, setShowError] = useState(false);
  const [lie, setLie] = useState("");
  const socket = useContext(SocketContext);
  const dispatch = useDispatch();

  useEffect(() => {
    socket.off("CHANGE_LIE");
    socket.off("LYING_OVER");

    socket.on("CHANGE_LIE", (data) => {
      if (data.name === name) {
        setShowError(true);
        setShow(1);
        dispatch(setLastAnswer(""));
      }
    });
    socket.on("LYING_OVER", (data) => {
      setShow(3);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendLie = (lie: string) => {
    if (lie.trim() !== "") {
      setShow(2);
      dispatch(setLastAnswer(lie));
      socket.emit("MY_LIE", { roomId: room, lie: lie, name: name });
      setShowError(false);
    }
  };

  return (
    <div
      id="lie"
      className="player-game-min relative w-screen overflow-x-hidden overflow-y-auto bg-join-background bg-cover"
    >
      {show === 1 && (
        <div className="flex w-full flex-col items-center px-4 py-4 player-game-safe-y">
          <h3 className="z-30 mx-4 mt-6 text-center font-Cairo text-2xl font-thin text-beige drop-shadow-sm xs:text-3xl desktop:mx-24 desktop:mt-12 desktop:text-7xl">
            {question}
          </h3>
          <h3 className="z-30 mx-4 mt-4 text-center font-Inter text-2xl font-bold text-beige drop-shadow-sm xs:text-3xl desktop:mt-8 desktop:text-7xl">
            {t("lie.enter")}
          </h3>
          <input
            type="text"
            className="z-30 mt-4 h-14 w-[85%] max-w-xl rounded-lg border-2 border-darker-blue bg-beige px-4 text-darker-blue text-xl desktop:mt-8 desktop:w-[50%] desktop:text-5xl"
            maxLength={30}
            onChange={(e) => {
              setLie(e.target.value);
            }}
          />
          {showError && (
            <h2 className="z-30 py-2 font-Inter text-2xl font-bold text-red xs:text-lg desktop:text-3xl">
              {t("lie.error")}
            </h2>
          )}
          <button
            className="z-30 mt-6 h-28 w-28 shrink-0 rounded-full border-2 border-dark-blue bg-light-blue font-Cairo text-3xl text-darker-blue desktop:mt-10 desktop:h-64 desktop:w-64 desktop:text-4xl"
            onClick={() => sendLie(lie)}
          >
            {t("lie.send")}
          </button>
        </div>
      )}
      {show === 2 && (
        <div className="flex w-full flex-col items-center justify-start px-4 py-8 player-game-safe-y">
          <h3 className="z-30 mx-4 mt-8 text-center font-Cairo text-2xl font-bold text-beige drop-shadow-sm xs:text-3xl phone:mt-6 desktop:mt-16 desktop:text-7xl">
            {t("lie.waiting")}
          </h3>
        </div>
      )}
      {show === 3 && (
        <div className="flex w-full flex-col items-center justify-start px-4 py-8 player-game-safe-y">
          <h3 className="z-30 mx-4 mt-10 text-center font-Cairo text-2xl font-bold text-beige drop-shadow-sm xs:text-3xl phone:mt-8 desktop:mt-24 desktop:text-7xl">
            {t("lie.all_lies_entered")}
          </h3>
        </div>
      )}
    </div>
  );
}
